module.exports = [{
      plugin: require('/home/dusan/Documents/Projects/abd.rs/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
